import { GetterTree } from 'vuex'
import { SubscriptionState } from './types'
import { RootState } from '../types'
export const getters: GetterTree<SubscriptionState, RootState> = {
  allSubscriptions(state){
    return state.subscriptions
  }
}
